import * as React from 'react';

export default class RetirementBar extends React.Component {

   render() {
      return (
         <div className="retirement-banner">
            Video Review will be retired on December 31, 2024. <a href="https://support.techsmith.com/hc/en-us/articles/28528155918349-Knowmia-Pro-and-Video-Review-Retirement-FAQ">Learn more</a>.
         </div>
      );
   }
}